// Small, framework-agnostic helpers for smooth scrolling.

export function getElement(nodeOrRef) {
  if (!nodeOrRef) return null;
  return nodeOrRef.current ? nodeOrRef.current : nodeOrRef;
}

/**
 * Scroll an element (or ref) into view smoothly, after the next paint.
 * We use 2x rAF to ensure layout + paint are done before scrolling.
 */
export function smoothScrollIntoView(
  nodeOrRef,
  { block = 'start', inline = 'nearest', behavior = 'smooth', offset = 0 } = {}
) {
  const el = getElement(nodeOrRef);
  if (!el) return;

  // If you need a fixed header offset, use window.scrollTo.
  if (offset !== 0) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const rect = el.getBoundingClientRect();
        const top = rect.top + window.pageYOffset - offset;
        window.scrollTo({ top, behavior });
      });
    });
    return;
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (typeof el.scrollIntoView === 'function') {
        el.scrollIntoView({ block, inline, behavior });
      } else {
        // Fallback if not an Element
        const rect = el.getBoundingClientRect();
        const top = rect.top + window.pageYOffset;
        window.scrollTo({ top, behavior });
      }
    });
  });
}
